import React from 'react';

const Footer = () => {
  // School data
  const schoolData = {
    name: 'Joseph C. Lanzetta School of the Arts, Collaboration, & Technology',
    address: '216 E 120th St, New York, NY 10035',
    phone: '(212) 860-5851',
    fax: '(212) 860-6074',
    echalkCode: '9L38X2',
    socialLinks: {
      instagram: 'https://www.instagram.com/ps96act/',
      facebook: 'http://www.facebook.com/PS96Lions',
    },
    quickLinks: {
      faculty: '/directory/faculty',
      calendar: '/calendar',
      parentPortal: 'https://mystudent.nyc/',
      announcements: '/announcements',
      directions: '/directions',
    },
  };

  return (
    <footer id="contact" className="bg-[#00213a] text-gray-400 pt-20 pb-10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16">
          {/* Brand */}
          <div className="lg:col-span-2">
            <div className="flex items-center gap-3 mb-6">
              <img
                src="/assets/images/ps96act_logo.png"
                alt="PS 96 Lions Logo"
                className="w-12 h-12 object-contain"
              />
              <div>
                <div className="text-white font-black text-xl">PS 96 Lions</div>
                <div className="text-sm text-gray-400">Lanzetta School</div>
              </div>
            </div>
            <p className="text-sm text-gray-400 mb-6 max-w-md leading-relaxed">
              {schoolData.name}
            </p>
            <div className="flex gap-3">
              <a
                href={schoolData.socialLinks.instagram}
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full bg-gray-800 hover:bg-[#fdbb2e] flex items-center justify-center transition-colors duration-200"
                aria-label="Instagram"
              >
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                  <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
                </svg>
              </a>
              <a
                href={schoolData.socialLinks.facebook}
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full bg-gray-800 hover:bg-[#fdbb2e] flex items-center justify-center transition-colors duration-200"
                aria-label="Facebook"
              >
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                  <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
                </svg>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h2 className="text-white font-bold mb-4">Quick Links</h2>
            <ul className="space-y-2 text-sm">
              <li><a href="/#about" className="hover:text-[#fdbb2e] transition-colors">About</a></li>
              <li><a href={schoolData.quickLinks.faculty} className="hover:text-[#fdbb2e] transition-colors">Staff Directory</a></li>
              <li><a href={schoolData.quickLinks.calendar} className="hover:text-[#fdbb2e] transition-colors">Calendar</a></li>
              <li><a href={schoolData.quickLinks.announcements} className="hover:text-[#fdbb2e] transition-colors">Announcements</a></li>
              <li><a href={schoolData.quickLinks.directions} className="hover:text-[#fdbb2e] transition-colors">Directions</a></li>
              <li><a href="/uniform_policy" className="hover:text-[#fdbb2e] transition-colors">Uniform Policy</a></li>
              <li><a href="/dual_language_programs" className="hover:text-[#fdbb2e] transition-colors">Dual Language</a></li>
              <li><a href={schoolData.quickLinks.parentPortal} target="_blank" rel="noopener noreferrer" className="hover:text-[#fdbb2e] transition-colors">Parent Portal</a></li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h2 className="text-white font-bold mb-4">Contact</h2>
            <ul className="space-y-3 text-sm">
              <li>{schoolData.address}</li>
              <li>{schoolData.phone}</li>
              <li className="text-gray-400">Fax: {schoolData.fax}</li>
            </ul>
            <div className="mt-6 p-4 rounded-xl bg-gray-800 border border-gray-700">
              <div className="text-white text-sm font-bold mb-1">eChalk Notify</div>
              <div className="text-xs text-gray-400 mb-2">Get instant updates</div>
              <div className="text-sm font-mono text-[#fdbb2e]">Code: {schoolData.echalkCode}</div>
            </div>
          </div>
        </div>

        <div className="pt-8 border-t border-gray-800 text-center text-sm text-gray-400">
          <p>&copy; {new Date().getFullYear()} {schoolData.name}</p>
          <p className="mt-1">Part of the New York City Department of Education</p>

          {/* NexSav Credit */}
          <div className="mt-4 pt-4 border-t border-white/5">
            <a
              href="https://nexsav.net"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center justify-center gap-2 text-white/60 hover:text-white/90 transition-all duration-300 group"
            >
              <img
                src="https://nexsav.net/static/media/logo.7ef8f9a8ca3ec946bd31.png"
                alt="NexSav Logo"
                className="h-5 opacity-60 group-hover:opacity-90 transition-opacity duration-300"
              />
              <span className="text-xs font-medium tracking-wide">
                Website designed & developed by <span className="font-semibold">NexSav</span>
              </span>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
